import { render } from "./Footer.vue?vue&type=template&id=13ce8dfe"
const script = {}

import exportComponent from "/Users/twchou/workspace/work/csunion/highschool_website/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__